<template>
<div>
  <div v-if="isLoaded">
    <div class="edit-spec">

    <div class="row">
      <div class="sixty">
        <div class="editable">
        <p>
        <label for="spec.title">Name</label>
        <input placeholder="Title" type="text" id="spec.title" v-model="spec.title">
        </p>
        </div>
      </div>
      <div class="thirty">
        <div class="explainer">
          <p>We'd recommend these documents having names that are short noun phrases, e.g. Migration Strategy for technology version X</p>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="sixty">
        <div class="editable">
        <p>
        <label for="spec.summary">Summary</label>
        <textarea placeholder="Add a summary" id="spec.summary" v-model="spec.summary"></textarea>
        <span class="spec-summary-counter">{{ specSummaryCount }}</span>
        </p>
        </div>
      </div>
      <div class="thirty">
        <div class="explainer">
        <p>A short description of the technical issue being addressed.</p>
        <p>Basically think of it as your elevator pitch to a board project manager</p>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="sixty">
        <div class="editable">
        <p>
        <label for="spec.status">Status</label>
        <select id="spec.status" v-model="spec.status">
          <option v-for="state in states" :value="state">{{state | capitalize }}</option>
        </select>
        </p>
        </div>
      </div>
      <div class="thirty">
        <div class="explainer">
        <p>What's the status of this spec?</p>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="sixty">
        <div class="editable">
        <p>
        <label for="spec.context">Context</label>
        <textarea placeholder="Add a context" id="spec.context" v-model="spec.context"></textarea>
        <span class="helper">You can use Markdown here</span>
        </p>
        </div>
      </div>
      <div class="thirty">
        <div class="explainer">
        <p>Describe the facts of the problem - the forces at play, including technological, political, social, and the motivation for change</p>
      </div>
      </div>
    </div>
    <div class="row">
      <div class="sixty">
        <div class="editable">
        <p>
        <label for="spec.consequences">Consequences</label>
        <textarea placeholder="Add consequences" id="spec.consequences" v-model="spec.consequences"></textarea>
        <span class="helper">You can use Markdown here</span>
        </p>
        </div>
      </div>
      <div class="thirty">
        <div class="explainer">
        <p>What are all the consequences? A particular decision may have positive, negative, and neutral consequences, but all of them affect the team and project in the future.</p>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="sixty">
        <div class="editable">
        <p>
        <label for="spec.decision">Decision</label>
        <textarea placeholder="Add a decision" id="spec.decision" v-model="spec.decision"></textarea>
        <span class="helper">You can use Markdown here</span>
        </p>
        </div>
      </div>
      <div class="thirty">
        <div class="explainer">
        <p>This is response to the context to the context. Ideally stated in full sentences, with active voice. "We will …"</p>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="sixty">
        <div class="editable">
        <h3 for="spec.services">Impacted Services</h3>

        <div v-if="services.length" class="qk-cols">
        <p v-for="service in services">
          <input type="checkbox" :id="'serviceImpacted'+service.id" :value="service" v-model="spec.services">
    <label :for="'serviceImpacted'+service.id">{{ service.serviceName }}</label>
        </p>
        </div>

        </div>
      </div>
      <div class="thirty">
        <div class="explainer">
        <p>What services are impacted directly by this specification?</p>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="sixty">
        <div class="editable">
          <div style="margin-left:auto; width:28%">
            <router-link to="/">Cancel</router-link>
            <input type="button" @click="createService" :value="buttonLabel">
          </div>
        </div>
      </div>
    </div>
  </div>
  </div>

  <div v-if="!isLoaded">
    <progress-ring radius="60" :progress="progress" stroke="4"></progress-ring>
  </div>

  <div class="modal-mask" v-if="showSuccessModal">
    <div class="modal-wrapper">
      <div class="modal-container">

        <div class="modal-header">
          <svg viewBox="-260 -10 600 90" xmlns="http://www.w3.org/2000/svg"><path d="M71.301-.241H10.695C5.148-.241.606 4.3.606 9.848v60.587c0 5.547 4.542 10.089 10.089 10.089h60.588c5.547 0 10.088-4.542 10.088-10.089V9.848C81.389 4.3 76.847-.241 71.301-.241zm-35.348 62.67L17.23 43.723l7.144-7.145 11.579 11.579 24.199-24.199 7.145 7.145c-.018 0-31.344 31.326-31.344 31.326z" fill="#ffffff"/></svg>
            AWESOME!
        </div>

        <div class="modal-body">
            {{ spec.title }} has been updated!
        </div>

        <div class="modal-footer">
            <router-link :to="{ name: 'spec-view', params: { specid: spec.id }}" tag="button" class="button" style="color: #ffffff; background:#ed4a65">See {{ spec.title }}</router-link>
        </div>
      </div>
    </div>
  </div>

</div>
</template>

<script>
import { Auth, Analytics } from 'aws-amplify'
import statemachine from '@/components/statemachine.js';
import ProgressRing from '@/components/progress-ring.vue'
import { RepositoryFactory } from '@/services/repositoryfactory'
const SpecRepository = RepositoryFactory.get('specs');
const ServiceRepository = RepositoryFactory.get('services');

export default {
  name: 'spec-credit',
  props: ['specid'],
  components: {
    ProgressRing
  },
  data: function () {
    return {
      isSaving: false,
      showSuccessModal: false,
      isLoaded: false,
      progress: 0,
      spec: null,
      services: null,
      sm: null,
      states: null,
      buttonLabel: null,
      html: {
        title: null
      }
    }
  },
  metaInfo () {
    return {
      title: this.html.title
    }
  },
  created() {
    this.fetch();
  },
  computed: {
    specSummaryCount() {
      return this.charactersLeft("summary");
    }
  },
  methods: {
    async fetch() {
      const interval = setInterval(() => {
        this.progress += 1;
        if (this.progress === 100)
          clearInterval(interval);
      }, 100);

      var core = SpecRepository.spec;

      if(this.specid) {
        const data = await SpecRepository.getSpec(this.specid);
        data.SPEC.version += 1;
        Object.assign(core, data.SPEC);
        this.sendAnalyticsEvent("edit");
        this.buttonLabel = "Edit Spec";
        this.html.title = "Editing " + data.SPEC.title;
      } else {
        this.buttonLabel = "Create Spec";
        this.html.title = "Create a new spec";
        this.sendAnalyticsEvent("create");
      }

      this.services = await ServiceRepository.getAllServices();
      this.spec = core;
      this.createSM(this.spec.status)
      this.isLoaded = true;
    },

    charactersLeft(counter) {
      var char = this.spec[counter].length,
      limit = 200;
      return (limit - char) + " / " + limit + " characters remaining";
    },

    createSM(state) {
      this.sm = new statemachine({
        initial: state,
        states: {
          'accepted':  { from: 'draft',  to: 'accept' },
          'rejected': { from: 'draft', to: 'reject' },
          'withdrawn':  { from: 'draft',    to: 'withdraw' },
          'deferred': { from: 'draft', to: 'defer' },
          'redraft': { from: 'defer', to: 'draft' },
          'finalise': { from: 'accept', to: 'final' },
          'unacceptable': { from: 'accept', to: 'reject' },
        }
      });
      this.states = this.sm.available()
    },

    sendAnalyticsEvent(eventName) {
      Analytics.record({
          name: "specs",
          attributes: {
              screen: eventName
          }
      });
    },

    async createService() {
      this.isLoaded = false;
      this.isSaving = true;
      var created = await SpecRepository.updateSpec(this.spec.id, this.spec);

      if(created.status == true) {
        this.displayModal();
        window.setTimeout(this.redirect, 10000);

      } else {
        // @todo errorModal
      }
    },

    redirect() {
      let url = `/specs/${this.spec.id}`;
      this.$router.push({ path: url });
    },

    displayModal() {
      this.showSuccessModal = true;
      var modal = document.getElementById("app");
      modal.scrollIntoView();
    }
  },
  filters: {
    capitalize: function (value) {
      if (!value) return ''
      value = value.toString()
      return value.charAt(0).toUpperCase() + value.slice(1)
    }
  }
}
</script>
<style>
.qk-cols {
  columns: 2 auto;
}
</style>
